<template>
  <div>
    <v-card rounded outlined>
      <div class="d-flex" style="overflow:hidden;">
        <div :style="{width:'9px', backgroundColor: getSummaryColor}">
          &nbsp;
        </div>
        <div style="width:100%" @click="showDetails = !showDetails" :class="{'param-title':false, 'param-title-selected':showDetails}">
          <v-card-title>
            {{$t("result.params."+param_key+".title")}}
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
              <score-bar
                  v-if="showDetails"
                  :options="{type:'title_bar',values:scores}"
              ></score-bar>
              <a class="subtitle-2 ml-2" style="text-decoration: none" href="javascript:void(0)">
                <span v-if="showDetails">{{ $t('result.toggle_summary') }}</span>
                <span v-else>{{ $t('result.toggle_detail') }}</span>
              </a>
            </div>
          </v-card-title>
          <!--summary bars-->
          <div v-if="!showDetails" class="px-5 mb-5">
            <v-card flat rounded>
              <v-card-text class="py-5">
                <score-bar
                    v-for="(param,index,key) in sortedParams"
                    :key="param.title"
                    :id="'param-summary-'+param.title"
                    :title="$t('result.params.'+param_key+'.'+param.title+'.title')"
                    :value="param.value"
                    :options="{type:'summary', scale: 3, average: true}"
                >
                </score-bar>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
      <div v-if="showDetails"
           style="width:100%;position:absolute;top:50px;"
           class="text-center d-print-none"
      >
          <v-btn @click="showDetailsLegend = !showDetailsLegend"
                 small elevation="0"
                 class="rounded-0"
          >
              <v-icon v-if="showDetailsLegend" color="green" small>mdi-text-box-check</v-icon>
              <v-icon v-else small>mdi-text-box-outline</v-icon>
          </v-btn>
      </div>
      <div v-if="showDetails && !showDetailsLegend">
          <v-divider></v-divider>
          <v-card-text>
              <div :class="{'bm-page-break-inside':index > 0}" v-for="(param,index,key) in sortedParams" :key="param.title" :id="'param-'+param.title" style="overflow:hidden">
                  <div class="d-flex justify-center align-center px-5 py-1">
                      <distribution
                              :title="$t('result.params.'+param_key+'.'+param.title+'.title')"
                              :value="param.value"
                              :distro="param.dist"
                              :options="{average: true, boldScore: true}"
                              type="parameter"
                      />
                  </div>
              </div>
          </v-card-text>
      </div>
      <div v-else-if="showDetails">
        <v-divider></v-divider>
        <v-card-text>
          <div :class="{'mt-5-print bm-page-break-inside':index > 0}" v-for="(param,index,key) in sortedParams" :key="param.title" :id="'param-'+param.title" style="overflow:hidden">
            <div>
              <div class="text-center px-5 mb-2 ">
                <span class="subtitle-1 font-weight-bold text-uppercase" :style="{borderBottom: getColor(param.value)+' 2px solid'} ">
                  {{ $t("result.params."+param_key+"."+param.title+".title") }}
                </span><br>
                <span class="body-2">{{ $t("result.params."+param_key+"."+param.title+".text") }}</span>
              </div>
            </div>
            <div class="d-flex justify-center align-center px-5 py-2">
                <distribution
                    :value="param.value"
                    :distro="param.dist"
                    :options="{average: true, boldScore: true}"
                    type="parameter"
                />
            </div>
            <v-card flat rounded color="back_accent" class="mt-3 ">
              <v-card-text class="text-center py-print" style="padding-top:20px;">
                <div v-for="(legend,key) in legends">
                  <score-bar
                      v-if="flagLegend(legend, param.value)"
                      :value="param.value"
                      :options="{type:'inline', scale: 3, average:true}"
                  ></score-bar>
                  <strong>{{ $t("result.params."+param_key+"."+param.title+".state."+key+".title") }}</strong>
                  ({{$t("result.legend."+key)}})
                  <p class="body-2">
                    {{ $t("result.params."+param_key+"."+param.title+".state."+key+".text") }}
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
  import Balls from "../Balls";
  import ScoreBar from "../ScoreBar";
  import Distribution from "@/components/team/distribution.vue";
  export default {
    name: 'teamParamSlot',
    props: ['param_key','params'],
    components: {
        Distribution,
      Balls,
      ScoreBar
    },
    data() {
      return {
        showDetails: false,
        scoreColor: 'transparent',
        showDetailsLegend: false,
      }
    },
    computed: {
     getSummaryColor() {
       let result_colors = this.$store.getters['app/colors']
       return result_colors[this.params.score.color]
      },
      sortedParams() {
        let params = []
        for (const [key, param] of Object.entries(this.params.parameters)) {
          params.push({title: key, value: param.value, dist: param.dist})
        }
        //params.sort((a, b) => (a.value > b.value) ? 1 : -1)
        return params
      },
      scores() {
        let scores = []
        for (let param in this.sortedParams) {
          scores.push(this.sortedParams[param].value)
        }
        return scores;
      },
      legends() {
       return this.$store.getters['app/legends']
      },
      showAll(){
        return this.$store.getters['diagnostic/showAll']
      },
      showLegends() {
        return this.$store.getters['diagnostic/showLegends']
      },
      result_colors() {
        return this.$store.getters['app/colors']
      },
      colors() {
        let result_colors = this.$store.getters['app/colors']
        let colors = {
          1: result_colors['red'],
          2: result_colors['red'],
          3: result_colors['lred'],
          4: result_colors['yellow'],
          5: result_colors['green'],
          6: result_colors['green'],
          7: result_colors['yellow'],
          8: result_colors['lred'],
          9: result_colors['red'],
          10:result_colors['red'],
          fill: result_colors.fill
        }
        return colors
      },
    },
    methods: {
      getColor(score){
        let numScore = Math.round(score)
        return this.colors[numScore]
      },
      flagLegend(legend, value) {
        if (value < 3 && legend === 1) {
          return true
        } else if (value >= 8 && legend === 10) {
          return true
        } else if (value >= 3 && value < 8 && legend === 5) {
          return true
        } else {
          return false
        }
      }
    },
    created() {
      this.showDetails = this.showAll
    },
    watch: {
      showAll: function(val) {
        this.showDetails = val
      },
      showLegends: function(val) {
        this.showDetailsLegend = val
      }
    }
  }
</script>
